import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ExteriorViewAccessories from '../../containers/exterior-view-accessories/index';

class AccessorySelector extends Component {
  static propTypes = {
    open: PropTypes.bool,
    accessoryLabel: PropTypes.string,
    colorInfo: PropTypes.arrayOf(
      PropTypes.shape({
        code: PropTypes.string,
        name: PropTypes.string,
        rgb: PropTypes.string,
      }),
    ),
    currentColorId: PropTypes.string,
    openAccessoryDetail: PropTypes.func,
    closeAccessoryDetail: PropTypes.func,
    openAccessorySelector: PropTypes.func,
    closeAccessorySelector: PropTypes.func,
    changeAccessories: PropTypes.func,
    children: PropTypes.node,
  };
  static defaultProps = {
    open: null,
    accessoryLabel: null,
    colorInfo: null,
    currentColorId: null,
    openAccessoryDetail: null,
    closeAccessoryDetail: null,
    openAccessorySelector: null,
    closeAccessorySelector: null,
    changeAccessories: null,
    children: null,
  };
  
  constructor(props) {
    super();
    this.props = props;
    //
    this.state = {
      selectedAccessoryIndexList: [],
      selectedAccessoryIdList: [],
      currentStep: 0,
      contentHeight: 0,
      pastStep: 0,
    };
  }
  
  render() {
    
    const {
      open,
      accessoryLabel,
      colorInfo,
      currentColorId,
      openAccessoryDetail,
      closeAccessoryDetail,
      openAccessorySelector,
      closeAccessorySelector,
      changeAccessories,
      children,
    } = this.props;
    
    //
    let rgb = 'transparent';
    let i, max;
    for (i = 0, max = colorInfo.length; i < max; i = i + 1) {
      const info = colorInfo[i];
      if (info.code === currentColorId) {
        rgb = info.rgb;
        break;
      }
    }
    //
    let stepCount = 0;
    let stepCount2 = 0;
    
    // ナビゲーション
    const renderNav = () => {
      return (
        <ul className="ExteriorView__accessory-selector__navigation">
          <li>
            <a className={'ExteriorView__accessory-selector__link-color' + ((open === false) ? ' current': '')}
               href="javascript:void(0)"
               onClick={(e) => {
                 e.preventDefault();
                 if (closeAccessorySelector) closeAccessorySelector();
               }}
            >
              {'BODY COLOR'}
            </a>
          </li>
          <li>
            <a className={'ExteriorView__accessory-selector__link-accessory' + ((open === true) ? ' current': '')}
               href="javascript:void(0)"
               onClick={(e) => {
                 e.preventDefault();
                 if (open === true) {
                   if (closeAccessorySelector) closeAccessorySelector();
                 } else {
                   if (openAccessorySelector) openAccessorySelector();
                 }
               }}
            >
              {'ACCESSORY'}
            </a>
          </li>
        </ul>
      )
    };
    
    // ステップ
    const renderStep = () => {
      if (children && 2 <= children.length) {
        return (
          <ul className="ExteriorView__accessory-selector__list-step">
            {children.map((child, index) => {
              if (child.type.displayName === 'ExteriorViewAccessories') {
                if (4 <= stepCount2) return null;
                stepCount2 += 1;
                return (
                  <li className={(this.state.currentStep + 1 >= stepCount2) ? 'current': ''}
                      key={index}>{stepCount2}</li>
                )
              } else {
                return null;
              }
            })}
          </ul>
        )
      } else {
        return null;
      }
    };
    
    // アクセサリー
    const renderAccessory = () => {
      if (children && 1 <= children.length) {
        return (
          <ol className="ExteriorView__accessory-selector__list-accessory">
            {children.map((child, index) => {
              if (child.type.displayName === 'ExteriorViewAccessories') {
                if (4 <= stepCount) return null;
                const currentStep = stepCount;
                let accessoryIndex = null;
                if (currentStep <= this.state.selectedAccessoryIndexList.length - 1) accessoryIndex = this.state.selectedAccessoryIndexList[currentStep];
                stepCount += 1;
                return (
                  <ExteriorViewAccessories {...child.props}
                                           open={(currentStep === this.state.currentStep) ? true: false}
                                           isFirst={(index <= 0) ? true: false}
                                           isLast={(children.length - 1 <= index) ? true: false}
                                           step={currentStep}
                                           selectedIndex={accessoryIndex}
                                           selectAccessoryIndex={(step, index, id) => {
                                             this.setAccessoryIndex(step, index, id);
                                           }}
                                           goToStep={(step) => {
                                             this.goToStep(step);
                                           }}
                                           closeAccessorySelector={()=> {
                                             closeAccessorySelector();
                                           }}
                                           clearAccessoryIndex={()=> {
                                             this.clearAccessoryIndex();
                                           }}
                                           isPrev={(this.state.currentStep < this.state.pastStep) ? true: false}
                                           key={index}
                                           accessoryLabel={accessoryLabel}
                                           openAccessoryDetail={openAccessoryDetail}
                  />
                )
              } else {
                return null;
              }
            })}
          </ol>
        )
      } else {
        return null;
      }
    };
    
    return (
      <div className={'ExteriorView__accessory-selector' + ((open === true) ? ' open': '') + ((!this.props.children || this.props.children.length <= 0) ? ' empty': '')}>
        
        {renderNav()}
        
        <div className="ExteriorView__accessory-selector__container">
          <div className="ExteriorView__accessory-selector__container2"
               ref="container2"
          >
            <div className="ExteriorView__accessory-selector__container3">
              
              {renderStep()}
            
              </div>
            
            {renderAccessory()}
          
          </div>
        </div>
      </div>
    )
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    setTimeout(() => {
      this.handleResize();
    }, 500)
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
  
  //
  handleResize = () => {
    this.setState({
      contentHeight: this.refs.container2.offsetHeight,
    });
  };
  
  setAccessoryIndex = (step, index, id) => {
    //console.log('setAccessoryIndex: step=' + step + ', index=' + index);
    let arr = this.state.selectedAccessoryIndexList;
    let arr2 = this.state.selectedAccessoryIdList;
    arr[step] = index;
    arr2[step] = id;
    if (this.props.children.length - 1 <= step || 4 <= step) {
      this.setState({
        currentStep: 0,
        selectedAccessoryIndexList: arr,
        selectedAccessoryIdList: arr2,
      });
      if (this.props.closeAccessorySelector) this.props.closeAccessorySelector();
      if (this.props.changeAccessories) this.props.changeAccessories(arr, arr2);
      //}
    } else {
      this.setState({
        currentStep: step + 1,
        selectedAccessoryIndexList: arr,
        selectedAccessoryIdList: arr2,
      })
    }
  };
  
  clearAccessoryIndex = () => {
    this.setState({
      currentStep: 0,
      selectedAccessoryIndexList: [],
      selectedAccessoryIdList: [],
    });
    //if (this.props.closeAccessorySelector) this.props.closeAccessorySelector();
    //if (this.props.changeAccessories) this.props.changeAccessories([], []);
  };
  
  goToStep = (step) => {
    const pastStep = this.state.currentStep;
    this.setState({
      currentStep: step,
      pastStep: pastStep,
    })
  };
  
}

export default AccessorySelector;



// WEBPACK FOOTER //
// ./src/containers/exterior-view/AccessorySelector.jsx